var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionpeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7 (Stroke)",
    d: "M27.1875 26.25C27.1875 26.25 29 26.25 29 24.375C29 22.5 27.1875 16.875 19.9375 16.875C12.6875 16.875 10.875 22.5 10.875 24.375C10.875 26.25 12.6875 26.25 12.6875 26.25H27.1875ZM12.728 24.375C12.7217 24.3742 12.7129 24.3731 12.7023 24.3712C12.6972 24.3703 12.6923 24.3694 12.6875 24.3685C12.6901 23.8734 12.99 22.438 14.0637 21.1421C15.0679 19.93 16.8249 18.75 19.9375 18.75C23.0501 18.75 24.8071 19.93 25.8113 21.1421C26.885 22.438 27.1849 23.8734 27.1875 24.3685C27.1827 24.3694 27.1778 24.3703 27.1727 24.3712C27.1621 24.3731 27.1533 24.3742 27.147 24.375H12.728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval (Stroke)",
    d: "M19.9375 13.125C21.9395 13.125 23.5625 11.4461 23.5625 9.375C23.5625 7.30393 21.9395 5.625 19.9375 5.625C17.9355 5.625 16.3125 7.30393 16.3125 9.375C16.3125 11.4461 17.9355 13.125 19.9375 13.125ZM25.375 9.375C25.375 12.4816 22.9405 15 19.9375 15C16.9345 15 14.5 12.4816 14.5 9.375C14.5 6.2684 16.9345 3.75 19.9375 3.75C22.9405 3.75 25.375 6.2684 25.375 9.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    d: "M12.5714 17.3999C11.9047 17.1794 11.1642 17.019 10.3426 16.937C9.93603 16.8964 9.50961 16.875 9.0625 16.875C1.8125 16.875 0 22.5 0 24.375C0 25.625 0.604167 26.25 1.8125 26.25H9.45465C9.19946 25.7173 9.0625 25.0859 9.0625 24.375C9.0625 22.4807 9.74626 20.5463 11.0378 18.9304C11.4791 18.3783 11.9913 17.8634 12.5714 17.3999ZM8.91758 18.7509C7.83463 20.463 7.25 22.415 7.25 24.375H1.8125C1.8125 23.8861 2.11019 22.4437 3.18865 21.1421C4.17724 19.949 5.89514 18.7869 8.91758 18.7509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval (Stroke)_2",
    d: "M2.71875 10.3125C2.71875 7.2059 5.1532 4.6875 8.15625 4.6875C11.1593 4.6875 13.5938 7.2059 13.5938 10.3125C13.5938 13.4191 11.1593 15.9375 8.15625 15.9375C5.1532 15.9375 2.71875 13.4191 2.71875 10.3125ZM8.15625 6.5625C6.15422 6.5625 4.53125 8.24143 4.53125 10.3125C4.53125 12.3836 6.15422 14.0625 8.15625 14.0625C10.1583 14.0625 11.7812 12.3836 11.7812 10.3125C11.7812 8.24143 10.1583 6.5625 8.15625 6.5625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionpeople);
export default __webpack_public_path__ + "static/media/Competitionpeople.2c9bb552d2dca9caef8ab978108c411b.svg";
export { ForwardRef as ReactComponent };